import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Modal, Box, Typography, IconButton, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { logger } from "../../utils/logger";

const ImportExcelModal = ({
  open,
  onClose,
  onFileChange,
  onSubmit,
  title = "Upload Excel File to Import Donor",
}) => {
  const { user } = useSelector((state) => state.auth);
  const prevOpenRef = useRef(open);

  useEffect(() => {
    if (open && !prevOpenRef.current) {
      // Modal opened
      logger.info("Import Excel Modal opened", {
        modalOpenedFor: title,
        username: user?.username,
        role: user?.role,
      });
    } else if (!open && prevOpenRef.current) {
      // Modal closed without import
      logger.info("Import Excel Modal closed without import", {
        modalClosedFor: title,
        username: user?.username,
        role: user?.role,
      });
    }
    prevOpenRef.current = open;
  }, [open, title, user]);
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        component="form"
        sx={{
          width: "90%",
          maxWidth: 900,
          backgroundColor: "white",
          borderRadius: 2,
          boxShadow: 3,
          outline: "none",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        <div
          style={{
            background: "#1976D2",
            color: "white",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px",
            borderBottom: "1px solid #ddd",
          }}
        >
          <Typography variant="h5">{title}</Typography>
          <IconButton
            onClick={onClose}
            color="inherit"
            data-log="Close Icon Button"
          >
            <CloseIcon sx={{ color: "white" }} />
          </IconButton>
        </div>

        {/* Body */}
        <div style={{ padding: "16px", textAlign: "center" }}>
          <input
            type="file"
            id="fileInput"
            accept=".xlsx, .xls"
            style={{
              fontSize: "22px",
              marginBottom: "16px",
              textAlign: "center",
              fontFamily: "sans-serif",
            }}
            onChange={onFileChange}
          />
        </div>

        {/* Footer */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "16px",
            borderTop: "1px solid #ddd",
          }}
        >
          <Button variant="contained" color="primary" onClick={onSubmit}>
            Upload
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={onClose}
            style={{ marginLeft: "8px" }}
          >
            Close
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default ImportExcelModal;
